import React, { forwardRef } from 'react';
import cx from 'classnames';
import * as ScrollArea from '@radix-ui/react-scroll-area';

type DropdownSurfaceProps = React.ComponentPropsWithoutRef<'div'> & {
    children: React.ReactNode;
    scrollAreaClassName?: string;
    viewportClassName?: string;
    scrollbarClassName?: string;
    thumbClassName?: string;
    viewportWrapper?: (viewport: React.ReactElement) => React.ReactNode;
};

const DropdownSurface = forwardRef<HTMLDivElement, DropdownSurfaceProps>(
    ({ children, className, scrollAreaClassName, viewportClassName, scrollbarClassName, thumbClassName, viewportWrapper, ...rest }, forwardedRef) => {
        const viewport = (
            <ScrollArea.Viewport className={cx('flos-custom-select-scroll-area-viewport', viewportClassName)} style={{ overflowY: undefined }}>
                {children}
            </ScrollArea.Viewport>
        );

        const wrappedViewport = viewportWrapper ? viewportWrapper(viewport) : viewport;

        return (
            <div ref={forwardedRef} className={cx(className)} {...rest}>
                <ScrollArea.Root type="auto" className={cx('flos-custom-select-scroll-area', scrollAreaClassName)}>
                    {wrappedViewport}
                    <ScrollArea.Scrollbar className={cx('flos-custom-select-scroll-area-scrollbar', scrollbarClassName)} orientation="vertical">
                        <ScrollArea.Thumb className={cx('flos-custom-select-scroll-area-thumb', thumbClassName)} />
                    </ScrollArea.Scrollbar>
                </ScrollArea.Root>
            </div>
        );
    }
);

DropdownSurface.displayName = 'DropdownSurface';

export type { DropdownSurfaceProps };
export { DropdownSurface };
export default DropdownSurface;
